import React from 'react';
import ChatMessage from './ChatMessage';
import { buildMessageBubble } from '../messageBubbleBuilder';

const ChatConversation = ({
  messages,
  messageEndRef,
  sessionInfo,
  chatError,
  onAuthSignIn,
}) => {
  const interactiveHandlers = {};

  return (
    <div className="flex flex-col justify-end min-h-full gap-4">
      {messages.map((message, index) => {
        const bubble = buildMessageBubble(message);
        return (
          <ChatMessage
            key={index}
            message={bubble}
            sessionInfo={sessionInfo}
            onAuthSignIn={onAuthSignIn}
            interactiveHandlers={interactiveHandlers}
          />
        );
      })}
      {chatError && (
        <div className="flex justify-center">
          <div className="max-w-xs lg:max-w-md px-4 py-2 rounded-2xl bg-red-900 bg-opacity-70 text-red-100 border border-red-500 shadow-md">
            <p className="text-sm font-semibold flex items-center space-x-2">
              <span>⚠️</span>
              <span>{chatError}</span>
            </p>
          </div>
        </div>
      )}
      <div ref={messageEndRef} />
    </div>
  );
};

export default ChatConversation;
